module.exports = __webpack_public_path__ + "img/avatarIco.d0e7e5c6.png";